import {API_BACKEND, API_URL} from '../../../../temp_iot/src/actions/types';
import { Table, Input, Button, Space, Image, Tag} from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined} from '@ant-design/icons';
import {Link, useParams} from 'react-router-dom';
import React, { Fragment, useEffect, useState  } from 'react';
import axios from "axios";
import moment from 'moment';
import XLSX from 'xlsx';
import {
  getUserID,
  getVehicleID
} from "../../actions/truck";

const DeductionForm = ({ record }) => {
  let params = useParams();
  const [vehicleId] = useState(params.vehicle_id);
  useEffect(() => {
    const sendRequest = async () => {
      const config = {
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer 710|pM8X4jvYMLantzl8Hmx2oRhH8vy9OFCE2qfswibQ'
        },
      }
      const body = {
        violations_list_id: Math.floor(Math.random() * 250) + 1,
        vehicle_id: 15,
        driver_id: 1,
        offense_level: Math.floor(Math.random() * 3) + 1,
        status: "In Progress",
        date_happened: moment(record.sensor_date, 'MM/YYYY/D HH:mm:ss').format('YYYY-MM-DD'),
        time_happened: moment(record.sensor_date, 'MM/YYYY/D HH:mm:ss').format('HH:mm:ss'),
        ml_violation: 1,
        created_by: 2041,
        ...record
      };
      const formData = new FormData();
      for (const key in body) {
        formData.append(key, body[key])
      }

      try {
        const results = await axios.get(API_BACKEND + `/api/vehiclesIOT/${vehicleId}`, config);
        const vehicleIdFromResponse = results.data.results.id;
        formData.set('vehicle_id', vehicleIdFromResponse);
        console.log(vehicleIdFromResponse);
        const userIdFromResponse = results.data.results.user_id_assigned;
        formData.set('driver_id', userIdFromResponse);
        console.log(userIdFromResponse);
      } catch (err) {
        console.error(err);
      }

      try {
        const res = await axios.post(API_BACKEND + '/api/createViolationIOT', formData, config);
        console.log(res.data);
      } catch (err) {
        if (err.response) {
          if (err.response.status === 400) {
            console.error('Bad Request:', err.response.data);
          } else if (err.response.status === 401) {
            console.error('Unauthorized:', err.response.data);
          } else {
            console.error('There was an error:', err.response.data);
          }
        } else {
          console.error('Network Error:', err.message);
        }
      }
    };

    sendRequest();
  }, []);

  return <></>;
};

class SensorTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    searchTerm: '',
    getCurrentSourceData: {},
  };

  setSearchTerm = () =>{
    this.setState({
      searchTerm: '',
    })
  }

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  onChange = (pagination, filters, sorter, extra) => {
    this.setState({
      getCurrentSourceData: extra.currentDataSource,
    });
  };

  downloadCSV = () => {
    
    let worksheet;
    if (this.state.getCurrentSourceData.length > 0) {
      const newData = this.state.getCurrentSourceData.map(row => {
        delete row.__v;
        return row;
      });
      worksheet = XLSX.utils.json_to_sheet(newData);
    } else {
      worksheet = XLSX.utils.json_to_sheet(this.props.sensorData);
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
    XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    //Binary string
    XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    //Download
    XLSX.writeFile(workbook, `sensory_data_${Date.now()}.xlsx`);
  };
  render() {
    const columns = [
      {
        title: 'Action',
        dataIndex: 'action',
        render: (text, record) => {
          return [
            <Link to={{
              pathname: `/monitor/${this.props.vehicleId}/${record._id}/review`,
              state: record,
            }}>
              <Button type='link'>View</Button>
            </Link>
          ]
          console.log(this.props.vehicleId)
        }
      },
      {
        title: 'Image',
        dataIndex: 'img_filepath',
        key: 'img_filepath',

        render: img_filepath => img_filepath ? (<Fragment>
          <Image width={"100%"} height={"100%"} src={API_URL+"/"+img_filepath} fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="/>
        </Fragment>):(<Fragment>

        </Fragment>)

      },
      {
        title: 'Sound Sensor',
        dataIndex: 'sound_sensor',
        key: 'sound_sensor',
        sorter:(a, b) => {
          return String(a.sound_sensor).localeCompare(String(b.sound_sensor))
        }
      },
      {
        title: 'Alcohol Sensor',
        dataIndex: 'alcohol_sensor',
        key: 'alcohol_sensor',
        sorter:(a, b) => {
          return String(a.alcohol_sensor).localeCompare(String(b.alcohol_sensor))
        }
      },
      {
        title: 'Ultrasonic Sensor',
        dataIndex: 'ultrasonic_sensor',
        key: 'ultrasonic_sensor',
        sorter:(a, b) => {
          return String(a.ultrasonic_sensor).localeCompare(String(b.ultrasonic_sensor))
        }
      },
      {
        title: 'Accelerometer X Axis',
        dataIndex: 'gyro_sensor_acceleration_x',
        key: 'gyro_sensor_acceleration_x',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_x).localeCompare(String(b.gyro_sensor_acceleration_x))
        }
      },
      {
        title: 'Accelerometer Y Axis',
        dataIndex: 'gyro_sensor_acceleration_y',
        key: 'gyro_sensor_acceleration_y',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_y).localeCompare(String(b.gyro_sensor_acceleration_y))
        }
      },
      {
        title: 'Accelerometer Z Axis',
        dataIndex: 'gyro_sensor_acceleration_z',
        key: 'gyro_sensor_acceleration_z',
        sorter:(a, b) => {
          return String(a.gyro_sensor_acceleration_z).localeCompare(String(b.gyro_sensor_acceleration_z))
        }
      },
      {
        title: 'Gyro Sensor Rotation X',
        dataIndex: 'gyro_sensor_rotation_x',
        key: 'gyro_sensor_rotation_x',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_x).localeCompare(String(b.gyro_sensor_rotation_x))
        }
      },
      {
        title: 'Gyro Sensor Rotation Y',
        dataIndex: 'gyro_sensor_rotation_y',
        key: 'gyro_sensor_rotation_y',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_y).localeCompare(String(b.gyro_sensor_rotation_y))
        }
      },
      {
        title: 'Gyro Sensor Rotation Z',
        dataIndex: 'gyro_sensor_rotation_z',
        key: 'gyro_sensor_rotation_z',
        sorter:(a, b) => {
          return String(a.gyro_sensor_rotation_z).localeCompare(String(b.gyro_sensor_rotation_z))
        }
      },
      {
        title: 'Gyro Sensor Temperature',
        dataIndex: 'gyro_sensor_temperature',
        key: 'gyro_sensor_temperature',
        sorter:(a, b) => {
          return String(a.gyro_sensor_temperature).localeCompare(String(b.gyro_sensor_temperature))
        }
      },
      {
        title: 'Latitude',
        dataIndex: 'latitude',
        key: 'latitude',
        sorter:(a, b) => {
          return String(a.latitude).localeCompare(String(b.latitude))
        }
      },
      {
        title: 'Longitude',
        dataIndex: 'longitude',
        key: 'longitude',
        sorter:(a, b) => {
          return String(a.longitude).localeCompare(String(b.longitude))
        }
      },
  
      {
        title: 'Vehicle Speed',
        dataIndex: 'max_gps_speed',
        key: 'max_gps_speed',
        sorter:(a, b) => {
          return String(a.max_gps_speed).localeCompare(String(b.max_gps_speed))
        }
      },
      {
        title: 'Sensor Date',
        dataIndex: 'sensor_date',
        key: 'sensor_date',
        sorter:(a, b) => {
          return String(a.sensor_date).localeCompare(String(b.sensor_date))
        },
      },
      {
        title: 'Sign',
        dataIndex: 'status_1',
        key: 'status_1',
        sorter:(a, b) => {
          return String(a.status_1).localeCompare(String(b.status_1))
        },
      },
      {
        title: 'Remark',
        dataIndex: 'status_2',
        key: 'status_2',
        filters: [
          {
            text: 'Good',
            value: 'good',
          },
          {
            text: 'Bad',
            value: 'bad',
          },
        ],
        onFilter: (value, record) => record.status_2.indexOf(value) === 0,
        render: (status_2, record) => {
          if (status_2 === 'bad') {
            return (
              <>
                <DeductionForm record={record} />
                <Tag color='red'>{status_2.toUpperCase()}</Tag>
              </>
            );
          }
        
          return status_2 === 'good' ? (
            <Tag color='green'>{status_2.toUpperCase()}</Tag>
          ) : (
            <></>
          );
        }
      },
      {
        title: 'Validation',
        dataIndex: 'status_4',
        key: 'status_4',
        filters: [
          {
            text: 'Validated',
            value: 'validated',
          },
          {
            text: 'Not-Validated',
            value: 'not-validated',
          },
        ],
        onFilter: (value, record) => record.status_4.indexOf(value) === 0,
        render: status_4 => {
          return [
            status_4 === 'validated' ? (
              <Tag color='green'>{status_4.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
            status_4 === 'not-validated' ? (
              <Tag color='red'>{status_4.toUpperCase()}</Tag>
            ) : (
              <></>
            ),
          ];
        },
      },
    ];
    return (
      <Fragment>
        
        <Table
          style={{ marginTop: "20px" }}
          columns={columns}
          onChange={this.onChange}
          dataSource={this.props.sensorData}
          key={this.props.sensorData._id}
          scroll={{ x: 3500, y: 1500 }}
          title={() => (
            <div style={{ justifyContent: 'right', display: 'flex' }}>
              <h3 style={{color: '#2db7f5' }}> </h3>{' '}
              <Button type='link' onClick={this.downloadCSV}>
                {' '}
                Download as XLSX{' '}
              </Button>
            </div>
            
          )}
          
          
          
          className="card"
          size='small'
        />
        
      </Fragment>
    );
  }
}

export default SensorTable;
